import React from 'react';
import PropTypes from 'prop-types';
import CategoryOption from '../CategoryOption';
import Dropdown from '../Dropdown';

const CategoryDropdown = ({
  category: {
    options = [],
    name: categoryName,
  } = {},
  closedCategories = {},
  toggleFilter,
  toggleFilterCategory,
  dropdownClosedIconSrc,
  dropdownOpenIconSrc,
  showProductCount,
}) => (
  <Dropdown
    title={categoryName}
    isClosed={closedCategories[categoryName]}
    toggleFilterCategory={toggleFilterCategory}
    categoryName={categoryName}
    dropdownClosedIconSrc={dropdownClosedIconSrc}
    dropdownOpenIconSrc={dropdownOpenIconSrc}
    showProductCount={showProductCount}
  >
    {
      options.map(({
        name,
        color,
        count,
        isSelected,
      }) => (
        <CategoryOption
          key={name}
          categoryName={categoryName}
          optionName={name}
          color={color}
          count={count}
          toggleFilter={toggleFilter}
          isSelected={isSelected}
          showProductCount={showProductCount}
        />
      ))
    }
  </Dropdown>
);

CategoryDropdown.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.any),
  }).isRequired,
  closedCategories: PropTypes.objectOf(PropTypes.bool).isRequired,
  toggleFilter: PropTypes.func.isRequired,
  toggleFilterCategory: PropTypes.func.isRequired,
  dropdownClosedIconSrc: PropTypes.string.isRequired,
  dropdownOpenIconSrc: PropTypes.string.isRequired,
  showProductCount: PropTypes.bool.isRequired,
};

export default CategoryDropdown;
